<template>
    <span class="question-icon">
        <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" :stroke="fill" stroke-opacity=".65" />
            <path
                d="M6.116 8.832V8.52c0-.359.065-.656.195-.894s.359-.483.684-.737c.387-.306.636-.544.747-.713.114-.17.171-.371.171-.606 0-.273-.091-.483-.273-.63-.183-.146-.445-.22-.787-.22-.309 0-.595.045-.859.133a6.1 6.1 0 00-.771.317l-.41-.86a4.298 4.298 0 012.123-.551c.638 0 1.145.156 1.519.469.374.312.562.743.562 1.293 0 .245-.036.463-.108.655-.071.189-.18.37-.327.542-.143.172-.392.397-.747.674-.303.237-.506.434-.61.59-.101.157-.152.367-.152.63v.22h-.957zm-.2 1.558c0-.492.24-.738.718-.738.234 0 .413.065.537.196.124.127.185.307.185.542 0 .23-.063.415-.19.551-.124.134-.301.2-.532.2-.231 0-.409-.065-.532-.195-.124-.133-.186-.319-.186-.556z"
                :fill="fill"
                fill-opacity=".65"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconQuestion',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
